/* eslint-disable react-hooks/exhaustive-deps */
import { Autocomplete, Box, TextField, useTheme } from "@mui/material"
import PageHeader from "../../../components/PageHeader/PageHeader"
import CustomDatePicker from "../../../components/CustomDatePicker/CustomDatePicker"
import PropTypes from "prop-types";

import { t } from "i18next"
import {  useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useFormikContext } from "formik"
import DynamicDropDownlist from "./DynamicDropDownlist";
import { searchDestination, searchTransportCompany } from "../../../actions/formAction";

const TowingInfo = ({isEdit}) => {
  const theme = useTheme();
  const formik = useFormikContext();
  const [mainData, setMainData] = useState({});


  const formReducser = useSelector((state) => state.form);

  useEffect(() => {
    if (formReducser.loading === "succeeded") {
      setMainData(formReducser.data);
    }
  }, [formReducser]);










  return (
    <>
      <PageHeader title={t('towingInformation')} />
      <Box
        sx={{
          margin: { xs: '24px 0', md: '64px 49px' },
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: 'repeat(4, 1fr)' },
          gap: { xs: 2, md: 4 },
       
         
          p: { xs: 2, md: 3 },
        }}
      >



 <DynamicDropDownlist
          label="Transport Company"
          formik={formik}
          fieldName="transportCompany"
          disabled={formik?.values?.status.id > 2}
          loadingKey="isLoadingTransportCompanyData"
          dataKey="transportCompany"
          fetchAction={searchTransportCompany}
          errorKey="transportCompany"
        />








        <CustomDatePicker
          disabled={ formik?.values?.status.id !==1}
          label={t("ETA Warehouse Arrival Date")}
          name="etaWarehouseArrivalDate"
          disableFuture={true}
        />



{formik?.values?.status.id !== 1 && 

       <CustomDatePicker
          disabled={ formik?.values?.status.id === 1 ||  formik?.values?.status.id !== 2}
          label={t("Warehouse Arrival Date")}
          name="warehouseArrivalDate"
          disableFuture={true}
        />
}
      </Box>


    </>
  )

} 


TowingInfo.propTypes = {
  isEdit: PropTypes.bool.isRequired,
};

export default TowingInfo;